import { useGetCodeListQuery } from "../features/api";
import { CODE_TYPE } from "../configs/constants";
import { DivisionDict } from "../components/default-constants";

type CodeList = {
  companyType: DivisionDict[];
  deactivatedReason: DivisionDict[];
  applicationStatus: DivisionDict[];
  applicationDetailStatus: DivisionDict[];
  applicationType: DivisionDict[];
  individualHandlingReason: DivisionDict[];
  announcementCategory: DivisionDict[];
  applicationFormType: DivisionDict[];
};

/**
 *
 * @returns コードリスト一覧を返却
 */
export const useCodelistHook = () => {
  // コードリスト取得
  const { codelist } = useGetCodeListQuery(undefined, {
    selectFromResult: ({ data }) => {
      let codelist: CodeList = {
        companyType: [],
        deactivatedReason: [],
        applicationStatus: [],
        applicationDetailStatus: [],
        applicationType: [],
        individualHandlingReason: [],
        announcementCategory: [],
        applicationFormType: [],
      };

      type dataType = typeof data;
      const companyType = CODE_TYPE.COMPANY_TYPE as keyof dataType;
      const deactivatedReason = CODE_TYPE.DEACTIVATED_REASON as keyof dataType;
      const applicationStatus = CODE_TYPE.APPLICATION_STATUS as keyof dataType;
      const applicationDetailStatus =
        CODE_TYPE.APPLICATION_DETAIL_STATUS as keyof dataType;
      const applicationType = CODE_TYPE.APPLICATION_TYPE as keyof dataType;
      const individualHandlingReason =
        CODE_TYPE.INDIVIDUAL_HANDLING_REASON as keyof dataType;
      const announcementCategory =
        CODE_TYPE.ANNOUNCEMENT_CATEGORY as keyof dataType;
      const applicationFormType =
        CODE_TYPE.APPLICATION_FORM_TYPE as keyof dataType;

      if (data) {
        codelist = {
          companyType: data[companyType],
          deactivatedReason: data[deactivatedReason],
          applicationStatus: data[applicationStatus],
          applicationDetailStatus: data[applicationDetailStatus],
          applicationType: data[applicationType],
          individualHandlingReason: data[individualHandlingReason],
          announcementCategory: data[announcementCategory],
          applicationFormType: data[applicationFormType]
        };
      }

      return { codelist: codelist };
    },
  });

  return codelist;
};
